/* filter data for user subscription data  */


export const namespaced = true

export const state = {
    wholesaler_id_list :[],
    subscription_plan_id_list :[],
    payment_method_list :[],
    filter_date_from : "",
    filter_date_to : "",
    filter_count:0,
}
export const mutations = {
    SET_SUBSCRIPTION_FILTER(state, {
        wholesaler_id_list,
        subscription_plan_id_list,
        payment_method_list,
        filter_date_from,
        filter_date_to,
        filter_count,
    }) {
        state.wholesaler_id_list = wholesaler_id_list
        state.subscription_plan_id_list = subscription_plan_id_list
        state.payment_method_list = payment_method_list
        state.filter_date_from = filter_date_from
        state.filter_date_to = filter_date_to
        state.filter_count = filter_count
    },
}
export const actions = {
    setSubscriptionFilter({
        commit
    }, items) {
        commit('SET_SUBSCRIPTION_FILTER', items)
    },
}
export const getters = {
    getSubscriptionFilter: state => {
        return state;
    },
}